<template>
  <div class="highcharts-light stacked-bar-chart chart-container">
    <highcharts :options="chartOptions" ref="chartComponent"></highcharts>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import DataService from '../../../../services/data.service';

noDataToDisplay(Highcharts);

export default {
  name: 'stacked-bar-chart',
  components: {
    highcharts: Chart
  },
  props: {
    chartSeries: {
      type: Array,
      default: () => []
    },
    dateRange: {
      type: Object,
      default: undefined,
    },
    filter: {
      type: Object,
      default: undefined
    },
    panel: {
      type: Object,
      default: () => {}
    },
  },
  data: function () {
    this.filter.activeFiltersUpdated.add(this.renewRegistration.bind(this));
    return {
      data: [],
    }
  },
  computed: {
    chartOptions: function() {
      let self = this;
      return {
        chart: {
          styledMode: true,
          type: 'column',
          height: 435
        },
        title: {
          text: undefined
        },
        lang: {
          noData: 'No Data To Display'
        },
        noData: {
          style: {
            fontSize: '14px',
            fontWeight: '400',
            color: '#253035',
            fontFamily: 'Proxima Nova'
          }
        },
        legend: {
          align: 'bottom',
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          itemMarginBottom: 6,
          symbolHeight: 15,
          useHTML: true,
          reversed: true,
          itemStyle: {
            fontSize: '14px',
            color: '#253035',
            fontFamily: 'Proxima Nova'
          },
        },
        tooltip: {
          style: {
            color: '#253035',
            fontFamily: 'Proxima Nova'
          },
          useHTML: true,
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        xAxis: {
          // categories: self.categories ? Array.from(self.categories) : [],
          type: 'category',
          labels: {
            autoRotation: [-45, -90],
          },
          title: {
            text: self.panel.xAxisTitle || ''
          },
        },
        yAxis: {
          title: {
            text: self.panel.yAxisTitle || ''
          },
        },
        series: self.data,
      }
    }
  },
  methods: {
    renewRegistration: function() {
      DataService.deregisterPanel(this.panel, this.filter, this.dateRange);
      DataService.registerPanel(this.panel, this.filter, this.dateRange, this.updateData.bind(this));
    },
    updateData: function(data) {
      let self = this;
      let valueColumn = this.panel.valueColumn;
      let nameColumn = this.panel.nameColumn;
      let groupByColumn = this.panel.groupByColumn;
      let extractedData = [];
      let categories = new Set();
      data.forEach((dataPoint) => {
        let name = dataPoint[nameColumn];
        let groupByValue = dataPoint[groupByColumn];
        let highchartsPoint = {
          name,
          y: dataPoint[valueColumn]
        };
        categories.add(name);
        if (groupByColumn) {
          let currentSeries = extractedData.find((series) => series.name === groupByValue);
          if (currentSeries) {
            currentSeries.data.push(highchartsPoint);
          } else {
            extractedData.push({
              name: groupByValue,
              data: [highchartsPoint]
            });
          }
        } else {
          extractedData.push(highchartsPoint);
        }
      });
      // make legend alphabetical
      extractedData.sort((a, b) => {
        return b.name.localeCompare(a.name);
      });
      extractedData.forEach(item => {
        item.name = item.name ? item.name.replace(/\([abcdefg]\) /,'') : '';
      })
      this.data = extractedData;

      if (self.$refs.chartComponent.$el) {
        for (let i = 1; i < 10; i++) {
          self.$refs.chartComponent.$el.classList.remove('hc-series-' + i);
        }
        let valueLength = this.data.length;
        if (this.data && valueLength > 1) {
          self.$refs.chartComponent.$el.classList.add('hc-series-' + Math.min(10, valueLength));
        }
      }

    }
  },
  mounted() {
    let self = this;
    // We need to wait a bit to call reflow here; $nextTick seems to be the cleanest option.
    this.$nextTick(() => {
      if (self.$refs.chartComponent) {
        self.$refs.chartComponent.chart.reflow();
      }
    });
    DataService.registerPanel(this.panel, this.filter, this.dateRange, this.updateData);
  },
  beforeDestroy() {
    DataService.deregisterPanel(this.panel, this.filter, this.dateRange);
  },
  watch: {
    dateRange: {
      handler: function(newRange, oldVal) {
        if (!newRange.startDate.isSame(oldVal.startDate) || !newRange.endDate.isSame(oldVal.endDate)) {
          this.renewRegistration();
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
.stacked-bar-chart.chart-container {
  min-width: 280px;
  .highcharts-container {
    margin: 0 auto;
    .highcharts-legend-item span {
      font-size: 14px;
    }
    .highcharts-series {
      //cursor: pointer;
    }
  }
}
</style>
